var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThreeChevron = function SvgThreeChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 128.5c0 .3 23.2 28 51.5 61.6 28.4 33.6 52 62.1 52.5 63.5.6 1.5.6 3.3 0 4.9-.5 1.3-24.3 30.1-52.9 64L17 384h79.7l53.4-63.2c29.4-34.8 53.4-64 53.4-64.8 0-.9-24-30-53.4-64.8L96.7 128H57.3c-21.6 0-39.3.2-39.3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 128.5c0 .3 23.2 27.9 51.5 61.5 28.4 33.5 52 62.1 52.5 63.5.6 1.6.6 3.4 0 5-.5 1.4-24.1 30-52.5 63.5-28.3 33.5-51.5 61.2-51.5 61.5s17.7.5 39.4.5h39.3l53.7-63.5c29.5-34.9 53.6-63.9 53.6-64.5s-24.1-29.6-53.6-64.5L241.8 128h-39.4c-21.7 0-39.4.2-39.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.6 129.2c.5.7 23.5 28.2 51.3 61.2 27.9 32.9 51.2 60.9 51.9 62.3.8 1.4 1.1 3.6.8 4.9-.4 1.3-24 30-52.6 63.9s-52 61.8-52 62c0 .3 17.7.5 39.4.5h39.4l54.1-64 54-64-54-64-54.1-64h-39.5c-31.3 0-39.3.3-38.7 1.2"
  }))));
};
export default SvgThreeChevron;